<template>
  <v-card class="com-mb-card rw-txt">
    <v-col class="com-mb-card-contents-none-border pa-0">
      <v-col class="com-mb-card-title px-0 pt-2 pb-0 ma-0">
        <span class="com-mb-card-title pl-2">発表文</span>
      </v-col>
    </v-col>
    <v-col class="com-mb-card-contents-none-border pa-0">
      <v-row v-if="selectedRwDetailRw" class="pa-2 pl-7 pr-4">
        <span class="rw-span-text" v-text="selectedRwDetailRw.text"></span>
      </v-row>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "rw-txt",
  computed: {
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rw[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-txt {
  width: 100%;

  .rw-span-text {
    white-space: pre-wrap;
    font-size: 0.8rem;
    width: 100%;
  }
}
</style>
